
export const TITLE_PAGES_BY_LANGUAGE = {
  productsLibrary: {
    en: "Products Library",
    es: "Biblioteca de Productos",
  },
  projectsLibrary: {
    en: "Projects Library",
    es: "Biblioteca de Proyectos",
  },
};
